// Function to check if element is present in the current scrollview area of the parent container
export function isScrolledIntoView(element, scrollDiv) {
    if (!scrollDiv.contains(element)) {
        return false;
    }
    const parentViewTop = scrollDiv.scrollTop;
    const parentViewBottom = parentViewTop + scrollDiv.offsetHeight;
    const elemTop = element.offsetTop;
    const elemBottom = elemTop + element.offsetHeight;
    return elemTop <= parentViewBottom && elemBottom >= parentViewTop;
}
export function removeAllChildren(el) {
    while (el.firstChild) {
        el.removeChild(el.firstChild);
    }
}
// Useful for restarting css animations without having to set a timout between removing and readding the animation class.
// Be careful using this since reflows are expensive
export function triggerReflow() {
    void document.body.offsetWidth;
}
// Stops scroll momentum from eg flicking trackpad or touchscreen.
// ios gets upset if you set scrollTop while scroll momentum is still going, calling this first will fix the issue
// Note the default values restored for overflowY and overflowX - auto for Y and hidden for X
export function stopScrollMomentum(el, overflowY, overflowX) {
    el.style.overflow = "hidden";
    triggerReflow();
    el.style.overflowY = overflowY !== null && overflowY !== void 0 ? overflowY : "auto";
    el.style.overflowX = overflowX !== null && overflowX !== void 0 ? overflowX : "hidden";
}
